import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';


@Injectable()
export class ServerService {

  public pattern_title;
  public sb_fmea_process: Subject<any> = new Subject();
  public sb_material_service_type: Subject<any> = new Subject();
  public sb_material_id: Subject<any> = new Subject<any>();
  public sb_ticket_unit_id: Subject<any> = new Subject<any>();
  public sb_process: Subject<any> = new Subject<any>();
  public isOnline: boolean;
  public server: any;
  isPrinting: boolean = false;
  public site = 'https://khanehaval.com';
  sms_token: string = "https://api.kavenegar.com/v1/57362B337778637973557376694B37717239636C7170566338355A2B7958614F/verify/lookup.json";

  public sb_list_tab: Subject<any> = new Subject<any>();
  public sb_list_section: Subject<any> = new Subject<any>();
  public sb_list_menu: Subject<any> = new Subject<any>();
  public sb_group: Subject<any> = new Subject<any>();
  public sb_cate: Subject<any> = new Subject<any>();
  public sb_services_id: Subject<any> = new Subject<any>();


  public sb_financial2: Subject<any> = new Subject<any>();
  public sb_invoice_material: Subject<any> = new Subject<any>();
  public sb_invoice: Subject<any> = new Subject<any>();
  public sb_bascket: Subject<any> = new Subject<any>();
  public sb_reset: Subject<any> = new Subject<any>();
  public sb_ckd_status: Subject<any> = new Subject<any>();
  public sb_ckd: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient, private matSnackBar: MatSnackBar
    , private router: Router) { }

  post_address_file(server, address, obj) {
    return this.http.post(server + "/" + address, obj, {
      'reportProgress': true,
      'observe': 'events'
    })
  }

  get_software_id() {
    return 2;
  }

  post_address(server, address, obj) {
    return this.http.post(server + "/" + address, obj);
  }//end manager_get_data

  get_address(server, address) {
    return this.http.get(server + "/" + address);
  }//end manager_get_data

  get_server() {
    return 'https://server-sale.khanehaval.com';
  }

  get_site() {
    return 'https://khanehaval.com';
  }

  get_currenct_site() {
    return 'https://sale.khanehaval.com';
  }

  get_site_upload_image() {
    return 'https://khanehaval.com';
  }

  get_path_upload_image() {
    return 'object/images/upload/';
  }

  no_record(): any {
    var text = " هیچ رکورد وجود ندارد";
    return text;
  }


  get_default_user_logo() {
    return "../../../../assets/images/default_user.png";
  }

  get_default_image() {
    return "../../../../assets/images/default_image.png";
  }


  status1(status) {
    this.matSnackBar.dismiss();
    if (status == 2) {
      if (JSON.parse(<any>localStorage.getItem('status')) != 1) {
        this.signout();
      }
    }//end if
  }

  get_number(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode >= 48 && charCode <= 57) || charCode == 13) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  get_number_float(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57) && charCode != 46) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }


  signout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  send_invoice(value: any) {
    this.sb_invoice_material.next(value);
  }

  get_invoice(): Observable<any> {
    return this.sb_invoice_material.asObservable();
  }

  //****************************************** */
  send_services_id(value) {
    this.sb_services_id.next(value);
  }

  get_services_id(): Observable<any> {
    return this.sb_services_id.asObservable();
  }
  //****************************************** */
  send_group() {
    this.sb_group.next();
  }

  get_group(): Observable<any> {
    return this.sb_group.asObservable();
  }
  //****************************************** */
  send_ckd_status() {
    this.sb_ckd_status.next();
  }

  get_ckd_status(): Observable<any> {
    return this.sb_ckd_status.asObservable();
  }
  //****************************************** */
  send_ckd() {
    this.sb_ckd.next();
  }

  get_ckd(): Observable<any> {
    return this.sb_ckd.asObservable();
  }
  //****************************************** */
  send_cate(value) {
    this.sb_cate.next(value);
  }

  get_cate(): Observable<any> {
    return this.sb_cate.asObservable();
  }
  //**************************************** */
  send_shop_process(value) {
    this.sb_process.next(value);
  }

  get_shop_process(): Observable<any> {
    return this.sb_process.asObservable();
  }
  //**************************************** */
  send_reset() {
    this.sb_reset.next();
  }

  get_reset(): Observable<any> {
    return this.sb_reset.asObservable();
  }
  //****************************************** */
  send_bascket(value: any) {
    this.sb_bascket.next(value);
  }

  get_bascket(): Observable<any> {
    return this.sb_bascket.asObservable();
  }
  //****************************************** */
  send_financial2(value: any) {
    this.sb_financial2.next(value);
  }

  get_financial2(): Observable<any> {
    return this.sb_financial2.asObservable();
  }
  //****************************************** */
  send_invoice_material(value: any) {
    this.sb_invoice.next(value);
  }

  get_invoice_material(): Observable<any> {
    return this.sb_invoice.asObservable();
  }
  //****************************************
  send_invoice_type(id: any) {
    this.sb_material_id.next(id);
  }
  get_invoice_type(): Observable<any> {
    return this.sb_material_id.asObservable();
  }
  //**************************************** */
  send_tab(result: any, action: string) {
    this.sb_list_tab.next({ result: result, action: action });
  }

  get_tab(): Observable<any> {
    return this.sb_list_tab.asObservable();
  }

  send_section(result: any, action: string) {
    this.sb_list_section.next({ result: result, action: action });
  }

  get_section(): Observable<any> {
    return this.sb_list_section.asObservable();
  }

  send_menu(result: any, action: string) {
    this.sb_list_menu.next({ result: result, action: action });
  }

  get_menu(): Observable<any> {
    return this.sb_list_menu.asObservable();
  }
  //**************************************** */

  print() {
    this.isPrinting = true;
    this.router.navigate(['/',
      {
        outlets: {
          'print': ['print']
        }
      }]);
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
      this.router.navigate([{ outlets: { print: null } }]);
    });
  }
  //******************************************************* */
  direction_text(value, box) {
    if (this.isUnicode(value)) {
      $("#" + box).css("cssText", "direction: rtl !important;text-align: right !important");
    }
    else {
      $("#" + box).css("cssText", "direction: ltr !important;text-align: left !important");
    }
  }

  isUnicode(str) {
    var letters = [];
    if (str.substring((0), 1).charCodeAt() > 255) { return true; }
    else {
      return false;
    }
  }



  //******************************************************* */

  pattern_title_with_persian() {
    this.pattern_title = "-()A-Za-z0-9 , ، \n / % آ ض ص ث ق ف غ ع ه خ ح ج چ پ ش س ی ب ل ا ت ن م ک ك گ ظ ط ز ر ذ د ئ ي و ژ . :";
    return this.pattern_title;
  }//end pattern_title_with_persian
  //*****************************************
  change_window_resize(start, object, num) {
    if (start == 1) {
      $("." + object).slideToggle("normal", function () {
        //var x = $(".content-body").offset().top + num;
        var x = 162;
        $(".content-body").css('height', 'calc(100vh - ' + x + 'px' + ')');
      });
    }//end ifs
    else {
      //var x = $(".content-body").offset().top + num;
      var x = 162;
      $(".content-body").css('height', 'calc(100vh - ' + x + 'px' + ')');
    }
  }//end change_resize

  window_dialog_size() {
    var x = 22;
    $(".content-body2").css('height', 'calc(100vh - ' + x + 'rem' + ')');
  }//end change_resize

  //*********************************************** */
  message_delete(id: any, changedRows: number): string {
    var number; var text;
    if (typeof id == 'number') { text = "با موفقیت حذف شد"; }
    else {
      number = id.length;
      text = " تعداد " + changedRows + " رکورد از " + number + " رکوورد انتخابی شما با موفقیت حذف شدند";
    }
    return text;
  }

  message_delete_alarm(): string {
    var text = "این رکورد در ماژول هایی در حال استفاده می باشد و قادر به حذف نخواهید بود";
    return text;
  }

  message_delete_accept(): any {
    var text = "آیا از حذف اطمینان دارید؟";
    return text;
  }

  message_error(): string {
    var text = "دریافت خطا";
    return text;
  }

  message_action(): string {
    return 'بستن';
  }
  //******************************************* */
  check_internet() {
    this.isOnline = navigator.onLine;
    if (this.isOnline == false) {
      return { 'status': false, 'title': 'Error in internet connecting' };
    }
    else {
      return true;
    }//end else
  }//end check_internet

  check_internet1() {
    this.isOnline = navigator.onLine;
    if (this.isOnline == false) {
      return false;
    }
    else {
      return true;
    }//end else
  }//end check_internet
  //******************************************* */
  readUrl(input_id, submit_id, image_id, type, size) {

  }//end readUrl

  upload_submit(input_id, whichImage, alarm_id, type_id, id, address, upload_type) {

  }//end upload_submit
  //******************************************* */

}
